import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { aplicarTemaInicial } from './app/core/theme/theme.service';

aplicarTemaInicial();

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
